let KeyCodes = /*#__PURE__*/function (KeyCodes) {
  KeyCodes[KeyCodes["Tab"] = 9] = "Tab";
  KeyCodes[KeyCodes["Enter"] = 13] = "Enter";
  KeyCodes[KeyCodes["Shift"] = 16] = "Shift";
  KeyCodes[KeyCodes["Escape"] = 27] = "Escape";
  KeyCodes[KeyCodes["Space"] = 32] = "Space";
  KeyCodes[KeyCodes["Up"] = 38] = "Up";
  KeyCodes[KeyCodes["Down"] = 40] = "Down";
  KeyCodes[KeyCodes["Zero"] = 48] = "Zero";
  KeyCodes[KeyCodes["One"] = 49] = "One";
  KeyCodes[KeyCodes["Two"] = 50] = "Two";
  KeyCodes[KeyCodes["Three"] = 51] = "Three";
  KeyCodes[KeyCodes["Four"] = 52] = "Four";
  KeyCodes[KeyCodes["Five"] = 53] = "Five";
  KeyCodes[KeyCodes["Six"] = 54] = "Six";
  KeyCodes[KeyCodes["Seven"] = 55] = "Seven";
  KeyCodes[KeyCodes["Eight"] = 56] = "Eight";
  KeyCodes[KeyCodes["Nine"] = 57] = "Nine";
  KeyCodes[KeyCodes["Backspace"] = 8] = "Backspace";
  KeyCodes[KeyCodes["Delete"] = 46] = "Delete";
  KeyCodes[KeyCodes["Left"] = 37] = "Left";
  KeyCodes[KeyCodes["Right"] = 39] = "Right";
  return KeyCodes;
}({});

export { KeyCodes };
//# sourceMappingURL=key-codes.js.map
